<template>
  <el-dialog
    :visible.sync="isShow"
    width="600px"
    :title="isEdit? '编辑精英机构' : '添加精英机构'"
    :close-on-click-modal="false"
    :top="isEdit ? '10vh' : '13vh'"
    custom-class="yioks_alert"
  >
    <el-form
      v-if="!loading"
      ref="centerInfo"
      :model="centerInfo"
      :rules="formRules"
      label-width="140px"
      style="height: 490px"
      class="demo-ruleForm">
      <vue-scroll :ops='ops'>
        <el-row v-if="!isEdit">
          <el-col :span="20">
            <el-form-item label="管理单位" prop="organUuid" >
              <el-select
                v-model="centerInfo.organUuid"
                placeholder="请选择管理单位"
                style="width: 100%;"
                @change="changeOrg">
                <el-option
                  v-for="(item,index) in selectOrganList"
                  :key="index"
                  :value="item.uuid"
                  :label="item.organShortName"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-else>
          <el-col :span="20">
            <el-form-item label="管理单位" prop="organUuid" >
              <p style="padding-left: 12px">{{centerInfo.organShortName}}</p>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="provinceCenter" >
          <div class="label">青训中心所属区域</div>
          <!-- <el-col :span="7">
            <el-form-item label="" label-width="0" prop="provinceCode">
              <el-select v-model="centerInfo.provinceCode" placeholder="请选择省" @change="changeProvince">
                <el-option
                  v-for="item in regions"
                  :key="item.code"
                  :value="item.code"
                  :label="item.name"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col> -->
          <el-col :span="7">
            <el-form-item label="" label-width="0" prop="cityCode">
              <el-select
                class="w_select"
                v-model="centerInfo.cityCode"
                placeholder="请选择市"
                @change="changeCityForYouthAdd" >
                <el-option
                  v-for="item in cityList"
                  :key="item.code"
                  :value="item.code"
                  :label="item.name"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="7" :offset="1">
            <el-form-item label="" label-width="0" prop="countyCode">
              <el-select
                class="w_select"
                v-model="centerInfo.countyCode"
                placeholder="请选择区"
                @change="changeCountyForYouthAdd" >
                <el-option
                  v-for="item in sh_county_list"
                  :key="item.code"
                  :value="item.code"
                  :label="item.name"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="20">
            <el-form-item label="青训中心全称" prop="youthName">
              <el-input v-model.trim="centerInfo.youthName" :disabled="isEdit" placeholder="请输入青训中心全称(50个字以内)"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="20">
            <el-form-item label="青训中心简称" prop="youthShortName">
              <el-input v-model.trim="centerInfo.youthShortName" :disabled="isEdit" placeholder="请输入青训中心简称(20个字以内)"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="20">
            <el-form-item label="管理员姓名" prop="idName">
              <el-input v-model.trim="centerInfo.idName" placeholder="请输入青训中心管理员姓名"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="20">
            <el-form-item v-if="isEdit" label="用户名">
              <el-input v-model.trim="centerInfo.loginName" :disabled="isEdit" placeholder="用户名以2位的小写字母开头和6位的数字组成" ></el-input>
            </el-form-item>
            <el-form-item v-else label="用户名" prop="loginName">
            <el-input v-model.trim="centerInfo.loginName" placeholder="用户名以2位的小写字母开头和6位的数字组成"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="20">
            <el-form-item label="手机号" prop="phone">
              <el-input v-model.trim="centerInfo.phone" placeholder="请输入手机号"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="isEdit">
          <el-col :span="20">
            <el-form-item label="青训中心状态" prop="status">
              <el-select v-model.trim="centerInfo.status" style="width: 100%">
                <el-option
                  v-for="(item, index) in centerStatusList"
                  :key="index"
                  :label="item.name"
                  :value="item.status"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="isEdit">
          <el-col :span="20">
            <el-form-item label="密码" prop="password">
              <el-input v-model.trim="centerInfo.password" placeholder="请输入将要更改的密码" type="password"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="20">
            <el-form-item label="确认密码" prop="confirmPassword">
              <el-input  v-model.trim="centerInfo.confirmPassword" placeholder="请输入确认密码" type="password"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="isEdit">
          <el-col :span="21">
            <el-form-item label="上传logo">
              <UploadImg :imgUrl.sync='centerInfo.banner ' :errImg="img" avatarUrl.sync="" />
              <div>支持jpg,jpeg,bmp,gif,png格式上传</div>
            </el-form-item>
          </el-col>
        </el-row>
      </vue-scroll>
    </el-form>
    <div v-if="!loading && !isEdit " class="tip">* 用户名将作为登录帐号，手机号作为登录的初始密码。</div>
    <div v-if="!loading" class="dialog_btn_wrap">
      <el-button
        type="primary"
        style="margin-right:20px"
        :loading="addbtnLoading"
        @click="addCenterOrg"
      >确定</el-button>
      <el-button type="danger" @click="isShow= false">取消</el-button>
    </div>
    <yioks-loading v-if="loading" style="height: 500px" />
  </el-dialog>
</template>

<script>
import storage from '@/utils/storage'
import rulesMixin from '@/utils/formRules/center'
import regions from '@/utils/regions'
// import { JSEncrypt } from 'jsencrypt'
import JSEncrypt from '@/assets/js/jsencrypt.min.js'
import auth from '@/api/auth'
import { centerStatusList } from '@/utils/yioks_data'
import center from '@/api/center'
import { ops } from '@/utils/scrollIndialog'
import centerImg from '@/assets/images/common/center.png'
export default {
  name: 'index',
  components: {
    'UploadImg': () => import('@/components/UploadImg')
  },
  mixins: [rulesMixin],
  props: {
    addCenter: {
      type: Boolean,
      required: true
    },
    organList: {
      type: Array,
      required: false
    },
    isEdit: {
      type: Boolean,
      required: false
    },
    centerUuid: {
      type: String,
      required: false
    }
  },
  data () {
    return {
      ops,
      img: centerImg,
      regions,
      cityList: [],
      loading: false,
      addbtnLoading: false,
      selectOrganList: [],
      centerStatusList,
      centerInfo: {
        idName: '',
        youthName: '',
        loginName: '',
        confirmPassword: '',
        youthShortName: '',
        organUuid: '',
        organShortName: '',
        provinceCode: '',
        provinceName: '',
        cityCode: '',
        cityName: '',
        countyCode: '',
        countyName: '',
        phone: '',
        status: '',
        password: '',
        banner: ''
      },
      userRole: storage.get('userInfo').userRole,
      uuid: storage.get('userInfo').uuid
    }
  },
  computed: {
    isShow: {
      get () {
        return this.addCenter
      },
      set (val) {
        this.$emit('update:addCenter', val)
      }
    },

    sh_county_list() {
      let arr = [];
      regions.forEach(item => {
        if(item.code === '31') {
          const { county, name } = item.city[0];
          arr = county
        }
      })
      return arr
    },
  },
  created () {
    if (this.centerUuid) {
      this.getCenterInfo()
    }
    if (this.organList && this.organList.length > 0) {
      this.selectOrganList = this.organList
      if (this.selectOrganList.length === 1) {
        this.$set(this.centerInfo, 'organUuid', this.selectOrganList[0].uuid)
        this.$set(this.centerInfo, 'organShortName', this.selectOrganList[0].organShortName)
      }
    }
    this.$set(this.centerInfo, 'provinceCode', '31')
    this.changeProvince();  // 已设置默认上海
  },
  methods: {
    getCenterInfo () {
      this.loading = true
      center.getCenterInfo(this.centerUuid).then((res) => {
        const { idName, loginName, phone } = res.user
        const { countyCode, countyName, cityName, cityCode, provinceName, provinceCode, youthName, youthShortName, organUuid, organShortName, status, id, banner } = res.youth
        this.centerInfo = {
          idName,
          cityName,
          id,
          countyCode: countyCode == 0 ? '' : String(countyCode),
          countyName,
          cityCode: String(cityCode),
          provinceName,
          provinceCode: String(provinceCode),
          youthShortName,
          phone,
          loginName,
          youthName,
          organUuid,
          organShortName,
          status,
          banner: banner || ''
        }
        this.setCityList()
        this.loading = false
      })
    },
    changeOrg () {
      this.centerInfo.organShortName = this.selectOrganList.find(item => {
        return item.uuid === this.centerInfo.organUuid
      }).organShortName
    },
    changeCityForYouthAdd () {
      this.centerInfo.cityName = this.cityList.find(item => {
        return item.code === this.centerInfo.cityCode
      }).name
    },
    changeCountyForYouthAdd() {
      this.centerInfo.countyName = this.sh_county_list.find(item => {
        return item.code === this.centerInfo.countyCode
      }).name || ''
    },
    changeProvince () {
      this.regions.forEach(item => {
        if (item.code === this.centerInfo.provinceCode) {
          this.cityList = item.city
          this.$set(this.centerInfo, 'cityCode', this.cityList[0].code)
          this.$set(this.centerInfo, 'cityName', this.cityList[0].name)
          this.centerInfo.provinceName = item.name
        }
      })
    },
    getOrgList () {
      let request, data
      if (this.userRole === 'system' || this.userRole === 'admin') {
        request = center.getListBySystem
        data = ''
      } else {
        request = center.getListByOrg
        data = this.uuid
      }
      request(data).then(res => {
        this.selectOrganList = res
      })
    },
    setCityList () {
      this.regions.forEach(item => {
        if (item.code === this.centerInfo.provinceCode) {
          this.cityList = item.city
        }
      })
    },
    addCenterOrg () {
      this.$refs['centerInfo'].validate(async valid => {
        if (valid) {
          this.addbtnLoading = true
          let requestName = center.addCenter
          let requestData = {
            youthForm: {
              provinceCode: this.centerInfo.provinceCode,
              provinceName: this.centerInfo.provinceName,
              cityCode: this.centerInfo.cityCode,
              cityName: this.centerInfo.cityName,
              countyCode: this.centerInfo.countyCode,
              countyName: this.centerInfo.countyName,
              organUuid: this.centerInfo.organUuid,
              organShortName: this.centerInfo.organShortName,
              youthName: this.centerInfo.youthName,
              youthShortName: this.centerInfo.youthShortName,
              banner: this.centerInfo.banner
            },
            userForm: {
              phone: this.centerInfo.phone,
              idName: this.centerInfo.idName,
              loginName: this.centerInfo.loginName
            }
          }
          if (this.isEdit) {
            requestName = center.updateCenter
            requestData.youthForm.status = this.centerInfo.status
            if (this.centerInfo.password) {
              let username = this.centerInfo.loginName
              // // ras 加密
              let publicKey = await auth.getPublicKey(username)
              let encryptor = new JSEncrypt()
              encryptor.setPublicKey(publicKey)
              let rsaPassword = encryptor.encrypt(this.centerInfo.password)
              requestData.userForm.password = rsaPassword
            }
            requestData.youthForm.id = this.centerInfo.id
          }
          requestName(requestData).then(res => {
            this.addbtnLoading = false
            if (res.code) {
              this.$message.error(res.msg)
            } else {
              this.$emit('hideDialog', false)
            }
          }).catch(err => {
            this.addbtnLoading = false
            console.error(err)
          })
        }
      })
    }
  }
}
</script>

<style scoped lang="stylus">
  .tip
    margin-top 10px
    color red
    width 100%
    text-align center
    word-break break-word
.w_select
  width 140px !important
</style>
<style lang="stylus">
  .provinceCenter
    display flex
    .label
      width: 140px;
      height 40px
      line-height 40px
      text-align center
      &:before
        content: '*';
        color: #F56C6C;
        margin-right: 4px;
</style>
